/**
 * Item ids read as fixed-width numbers in the UI: 1 shows as 001, 24 as 024.
 *
 * Display only. The stored id stays a plain integer, so sorting, filtering,
 * URLs (/items/24) and exports are unaffected by this. Ids that have already
 * outgrown the pad width are left alone rather than truncated, so the day the
 * table passes 999 nothing breaks -- item 1000 just renders as 1000.
 */

export const ITEM_ID_PAD_LENGTH = 3;

/** 24 -> "024". Non-numeric input is passed through untouched. */
export const formatItemId = (id) => {
  if (id === null || id === undefined) return '';

  const text = String(id).trim();
  if (!/^\d+$/.test(text)) return text;

  return text.padStart(ITEM_ID_PAD_LENGTH, '0');
};

/** 24 -> "#024". The form used in headings, badges and toasts. */
export const formatItemRef = (id) => {
  const formatted = formatItemId(id);
  return formatted ? `#${formatted}` : '';
};

/**
 * True when `term` looks like the user searching for this id, whether they
 * typed it padded or not: "24", "024" and "#024" all match item 24.
 */
export const matchesItemId = (id, term) => {
  if (id === null || id === undefined) return false;

  const needle = String(term ?? '').trim().replace(/^#/, '');
  if (!needle) return false;

  return String(id).includes(needle) || formatItemId(id).includes(needle);
};
